export enum OrdersView {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  HISTORY = 'HISTORY',
  VISITORS = 'VISITORS',
}
